export const DEFAULT = 'default';
export const BLANK = 'blank';
export const SHADE = 'on-shade';
export const DARK = 'on-dark';